
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { AuthModal } from "./AuthModal";
import { User } from "@supabase/supabase-js";
import { useLocation } from "react-router-dom";

interface AuthModalManagerProps {
  user: User | null;
  authLoading: boolean;
}

export const AuthModalManager = ({ user, authLoading }: AuthModalManagerProps) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { toast } = useToast();
  const location = useLocation();
  
  useEffect(() => {
    // Check if we're on a connection invite route
    const isConnectionRoute = location.pathname.startsWith('/connect/');
    
    // Always show the auth modal on the /auth route or connection routes for non-authenticated users
    if (location.pathname === '/auth' || (isConnectionRoute && !user && !authLoading)) {
      setIsAuthModalOpen(true);
    }
  }, [location, user, authLoading]);

  useEffect(() => {
    if (!authLoading && !user && location.pathname !== '/auth' && !location.pathname.startsWith('/connect/')) {
      toast({
        title: "Welcome to Goal to Action",
        description: "Sign in to save your goals and track your progress!",
      });
    }
  }, [user, authLoading, toast, location]);

  return (
    <AuthModal open={isAuthModalOpen} onOpenChange={setIsAuthModalOpen} />
  );
};
